{
  "instances": {
    "scheduledtasks": {
      "label": "Scheduled Tasks",
      "no_scheduledtasks": "No scheduled tasks present.",
      "last_execution": "Last Execution",
      "last_execution_status": "Last Execution State",
      "next_execution": "Next Execution",
      "cron": {
        "expression": "Expression",
        "runnable": "Runnable",
        "title": "Cron"
      },

      "fixed_delay": {
        "initial_delay_ms": "Initial Delay (ms)",
        "interval_ms": "Interval (ms)",
        "runnable": "Runnable",
        "title": "Fixed Delay"
      },
      "fixed_rate": {
        "initial_delay_ms": "Initial Delay (ms)",
        "interval_ms": "Interval (ms)",
        "runnable": "Runnable",
        "title": "Fixed Rate"
      }
    }
  }
}
